var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-progress-linear',{attrs:{"color":"white","striped":"","value":_vm.progress}})
}
var staticRenderFns = []

export { render, staticRenderFns }